module.exports = __webpack_public_path__ + "img/e_3_6_g.30d4c8a7.png";